module.exports = __webpack_public_path__ + "img/banner_kejian.3cb28659.png";